import React, { useState } from 'react';
import {
  makeStyles,
  createStyles,
  Theme,
  Grid,
  Popover
} from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { Draggable, Droppable } from 'react-beautiful-dnd';
import { DetailItem } from './DetailItem';
import {
  TCategoryItem,
  TCategoryDetailItem
} from '../../types/partnerCategory';
import { ButtonList } from './ButtonList';
import './style.css';

type Tprops = {
  item: TCategoryItem;
  index: number;
  setSelectItem: any;
  detailItemFlg: boolean;
  setDetailItemFlg: React.Dispatch<React.SetStateAction<boolean>>;
  setCreateModal: React.Dispatch<React.SetStateAction<boolean>>;
  setUpdateModal: React.Dispatch<React.SetStateAction<boolean>>;
  setDeleteModal: React.Dispatch<React.SetStateAction<boolean>>;
  handleCloseSuccess: () => void;
};

export const Item: React.FC<Tprops> = (props: Tprops) => {
  const {
    item,
    index,
    setSelectItem,
    detailItemFlg,
    setDetailItemFlg,
    setCreateModal,
    setUpdateModal,
    setDeleteModal,
    handleCloseSuccess
  } = props;

  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      ItemText: {
        width: '100%',
        display: 'flex',
        alignItems: 'start',
        justifyContent: 'space-between'
      },
      vertButton: {
        cursor: 'pointer',
        margin: '12px 24px',
        borderRadius: '50%'
      }
    })
  );

  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <>
      <Draggable index={index} draggableId={`large-${item.id}`} key={item.id}>
        {provided => (
          <Grid
            container
            className='categoryItem'
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            ref={provided.innerRef}
          >
            <Grid item xs={3} className={classes.ItemText}>
              {/* 項目 */}
              <div>
                <div style={{ padding: 20 }}>{item.name}</div>
                {item.registered > 0 && (
                  <div
                    style={{ paddingLeft: 20, fontSize: 14, color: '#52555f' }}
                  >
                    登録社数:{item.registered}
                  </div>
                )}
              </div>
              {/* ケバブボタン */}
              <div className='menuButton'>
                <MoreVertIcon
                  className={classes.vertButton}
                  aria-describedby={id}
                  onClick={(event: any) => {
                    handleCloseSuccess();
                    handleClick(event);
                    setSelectItem(item);
                    setDetailItemFlg(false);
                  }}
                />
                {/* ボタンリスト */}
                <Popover
                  id={id}
                  open={open}
                  anchorEl={anchorEl}
                  onClose={handleClose}
                  anchorOrigin={{ vertical: 'center', horizontal: 'right' }}
                  transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                >
                  <ButtonList
                    item={item}
                    detailItemFlg={detailItemFlg}
                    setDetailItemFlg={setDetailItemFlg}
                    setCreateModal={setCreateModal}
                    setUpdateModal={setUpdateModal}
                    setDeleteModal={setDeleteModal}
                    handleClose={handleClose}
                  />
                </Popover>
              </div>
            </Grid>
            <Grid item xs={9}>
              <Droppable droppableId={`ind-${index}`} type='small'>
                {provided => (
                  <Grid
                    container
                    {...provided.droppableProps}
                    ref={provided.innerRef}
                  >
                    {item.category_detail &&
                      item.category_detail.map(
                        (
                          detailItem: TCategoryDetailItem,
                          detailIndex: number
                        ) => (
                          // 小項目
                          <DetailItem
                            item={detailItem}
                            index={detailIndex}
                            setSelectItem={setSelectItem}
                            setCreateModal={setCreateModal}
                            detailItemFlg={detailItemFlg}
                            setDetailItemFlg={setDetailItemFlg}
                            setUpdateModal={setUpdateModal}
                            setDeleteModal={setDeleteModal}
                            handleCloseSuccess={handleCloseSuccess}
                          />
                        )
                      )}
                    {provided.placeholder}
                  </Grid>
                )}
              </Droppable>
            </Grid>
          </Grid>
        )}
      </Draggable>
    </>
  );
};
